export type FieldErrors = Record<string, string | string[]>;
export interface RejectValue { message?: string; fieldErrors?: FieldErrors }
export const EMPTY_FIELD_ERRORS: FieldErrors = {};
